import React from "react";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";

const PaymentModelSelector = ({ formik, handlePaymentModelChange }) => {
	return (
		<FormControl fullWidth>
			<label style={{ margin: "10px 0px" }}>
				Payment Model
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</label>
			<Select
				id="payment-model"
				name="paymentModel"
				value={formik.values.paymentModel}
				onChange={handlePaymentModelChange}
			>
				<MenuItem disabled value="">
					<em>Select Payment Model</em>
				</MenuItem>
				<MenuItem value="SubscriptionModel">
					Subscription Model
				</MenuItem>
				<MenuItem value="MilestoneModel">Milestone Model</MenuItem>
				<MenuItem value="RevenueShare">Revenue Share</MenuItem>
			</Select>
			{formik.errors.paymentModel && formik.touched.paymentModel && (
				<Typography variant="caption" color="error">
					{formik.errors.paymentModel}
				</Typography>
			)}
		</FormControl>
	);
};

export default PaymentModelSelector;
